var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"shrink mt-1",attrs:{"alt":"NoMoreHaters","contain":"","min-width":"100","src":require("@/assets/logo.svg"),"width":"100"}})}
var staticRenderFns = []

export { render, staticRenderFns }